import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import { l1verticalCardWidth } from "../data";
const L1VerticalCardSkeleton = ({ sx }) => {
	return (
		<Box sx={{ ...sx, minWidth: l1verticalCardWidth, height: "48rem", background: "white" }}>
			<Skeleton sx={{ width: "100%", height: "100%" }} variant="rectangular" animation="wave" />
		</Box>
	);
};

export default L1VerticalCardSkeleton;
